import { createLoyaltyizationImpressionEvent } from './loyalty';
import { createGigDescriptionImpressionEvent } from './gigDescription';

export const ImpressionEvents = {
    'loyalty_banner': createLoyaltyizationImpressionEvent('returning_buyers_banner'),
    'gig_description': createGigDescriptionImpressionEvent('gig_description_is_shown')
};
